export default {
    data(){
        return{
            index:0,
            message:'',
            oldPassword:'',
            newPassword:'',
            confirmPassword:'',
            personageMessage:'',
            isPersonageMessage:false,
            users:{
                name:'',
                company:'',
                email:'',
                idcard:'',
            }
        }
    },
    methods:{
		//返回上一层
		routerBack(){
			this.$router.go(-1)
		},
        //旧密码框获取焦点
        OldPasswordFocus: function () {
            if (this.personageMessage === '旧密码不能为空' || this.personageMessage === '旧密码不正确') {
                this.isPersonageMessage = false;
            }
        },
        //密码框获取焦点
        PasswordFocus: function () {
            if (this.personageMessage === '密码不能为空' || this.personageMessage === '两次密码不匹配') {
                this.isPersonageMessage = false;
            }
        },
        //确认密码框获取焦点
        AffirmPasswordFocus: function () {
            if (this.personageMessage === '确认密码不能为空' || this.personageMessage === '两次密码不匹配') {
                this.isPersonageMessage = false;
            }
        },

        getusers: function () {
            this.$post('users/profile', { token: this.$store.state.id }).then(res => {
                this.users.name = res.data.result.name;
                this.users.company = res.data.result.company;
                this.users.email = res.data.result.email;
                this.users.idcard = res.data.result.idcard; 
                this.users.name?document.querySelector('#name').setAttribute("disabled","disabled"):this.users.name;
            })
        },
        //邮箱校验
        checkEmail(){
            if(this.users.email != ''){
                let emsreg = /^([a-zA-Z0-9]+[_|\_|\.]?)*[a-zA-Z0-9]+@([a-zA-Z0-9]+[_|\_|\.]?)*[a-zA-Z0-9]+\.[a-zA-Z]{2,3}$/;
                if (!emsreg.test(this.users.email)) {
                    // // console.log('邮箱格式错误')
                  }
                  else{
                    // savePersonal()
                  }
                }
                else{
                    // savePersonal()
                }
        },
        savePersonal() {
            // // console.log(this.checkEmail());
                this.$post('users/edit', { token: this.$store.state.id, name: this.users.name, email: this.users.email, company: this.users.company, idcard: this.users.idcard }).then(res => {
                    if (res.data.status === 'fail') {
                        this.message='修改失败';
                        let model = document.querySelector('#modal-close-default-two');
                        UIkit.modal(model).show();
                        // this.$message.error('修改失败');
                    } else {
                        // this.$message.success('修改成功');
                        this.message='修改成功';
                        this.$store.state.name=this.users.name;
                        let model = document.querySelector('#modal-close-default-two');
                        UIkit.modal(model).show();
                        this.getusers();
                    }
                })
            // }
            
            
        },
    },
    created(){
        this.getusers();
    },
    mounted(){
        document.title='编辑个人信息';
    }


    
}